import React from "react";
import { Button, Stack } from "@mui/material";

interface Props {
  isLoading: boolean;
  onCancel: VoidFunction;
}

export const QuoteActions = ({ isLoading, onCancel }: Props) => {
  return (
    <Stack direction="row" gap="0.5rem" justifyContent="flex-end">
      <Button loading={isLoading} onClick={onCancel}>
        Cancel
      </Button>

      <Button loading={isLoading} type="submit" variant="contained">
        Confirm
      </Button>
    </Stack>
  );
};
